// src/services/auth.ts
import {
  getIdToken,
  User,
  signOut,
} from 'firebase/auth';
import { auth } from '../firebase';
import { AUTH_API_BASE_URL } from '../config/env';


// **************
// Post-login helpers
// **************
export async function getUserIdToken(user: User): Promise<string> {
  return await getIdToken(user);
}

export async function saveUserIdentityViaAPI(user: User) {
  const token = await getUserIdToken(user);

  const res = await fetch(`${AUTH_API_BASE_URL}/auth/login`, {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ idToken: token }),
  });

  if (!res.ok) throw new Error('Login via auth-api failed');

  const data = await res.json();
  console.log('Auth API response:', data);
  // Store sessionId from response for logout functionality
  if (data.sessionId) {
    localStorage.setItem('sessionId', data.sessionId);
  }
  return data;
}

/**
 * Logs out the user by:
 * 1. Calling the auth API to invalidate the session on the server
 * 2. Signing out from Firebase
 * 3. Clearing local storage
 * @returns Promise<boolean> indicating if logout was successful
 */
export async function logout(): Promise<boolean> {
  try {
    const sessionId = localStorage.getItem('sessionId');

    // If we have session ID and token, call the API to invalidate the token
    if (sessionId) {
      try {
        // Call the auth API to revoke the session
        const res = await fetch(`${AUTH_API_BASE_URL}/auth/logout`, {
          method: 'POST',
          credentials: 'include',
          headers: {
          'Content-Type': 'application/json'
          },
          body: JSON.stringify({ sessionId }),
        });

        if (!res.ok) {
          console.warn(`Logout API responded with ${res.status}: ${await res.text()}`);
        } else {
          console.log('Session successfully revoked on server');
        }
      } catch (apiError) {
        // Log API errors but continue with client-side logout
        console.error('Error calling logout API:', apiError);
      }
    } else {
      console.warn('Missing sessionId or token for server logout');
    }

    // Always sign out from Firebase
    await signOut(auth);

    // Always clear local storage
   // localStorage.removeItem('auth_token');
    localStorage.removeItem('sessionId');
    localStorage.removeItem('user');
    localStorage.removeItem('userRole');
    localStorage.removeItem('userProfile');
    localStorage.removeItem('emailForSignIn');

    console.log('Logged out successfully');
    return true;
  } catch (error) {
    console.error('Logout error:', error);

    // Try to clear local storage even if the above steps fail
    try {
    //  localStorage.removeItem('auth_token');
      localStorage.removeItem('sessionId');
      localStorage.removeItem('user');
      localStorage.removeItem('userRole');
      localStorage.removeItem('userProfile');
      localStorage.removeItem('emailForSignIn');
    } catch (storageError) {
      console.error('Error clearing localStorage:', storageError);
    }

    return false;
  }
}

/**
 * Checks if user is logged in based on auth token
 * @returns boolean
 */
export function isLoggedIn(): boolean {
  return !!localStorage.getItem('sessionId');
}

/**
 * Gets the user's role
 * @returns string | null
 */
export function getUserRole(): string | null {
  return localStorage.getItem('userRole');
}
